import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useIntl } from "react-intl";

import { faInfo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ActionState = (props) => {
    const intl = useIntl();
    let text = props.text || intl.messages.stateNoItem;

    return (
        <Link to={props.to} className="h-100 text-decoration-none">
            <div className={"state bordered py-3 " + props.className} >
                <span className="state-icon">
                    <FontAwesomeIcon icon={props.icon} />
                </span>
                <span><h4>{text}</h4></span>
                { props.desc && <span className="px-3"><h5>{props.desc}</h5></span> }
            </div>
        </Link>
    );
}

ActionState.defaultProps = {
    icon: faInfo,
    text: "",
    desc: "",
    className: "state-green",
}

ActionState.propTypes = {
    icon: PropTypes.object,
    text: PropTypes.string,
    desc: PropTypes.string,
    className: PropTypes.string
};

export default ActionState;